import React, {Fragment, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import {selectActiveOrganization} from "../../../store/reducers/auth/authReducer";
import {Translate} from "../../../lang/lang";
import {
    exportCompanyCatalogsToExcel,
    getBankNameAsync,
    getOrganizationInfoAsync,
    invalidateCompanyClassCodesAsync, loadCompanyProductCatalogsAsync
} from "../../../store/reducers/roaming/roamingReducer";
import toast from "react-hot-toast";
import {excelFileUploader} from "../../../helpers/excel-uploader";
import {Col, Row} from "react-bootstrap";
import Flex from "../../common/Flex";
import IconButton from "../../IconButton";
import {faFileExport, faRefresh} from "@fortawesome/free-solid-svg-icons";
import OrganizationChooser from "../../organization/OrganizationChooser";
import RegisterOrganizationInn from "../RegisterOrganizationInn";

const ProfileSettings = () => {
    const [organization, setOrganization] = useState(null);
    const activeOrganization = useSelector(selectActiveOrganization)
    const lang = useSelector(selectLang);
    const dispatch = useDispatch();
    const t = Translate;

    useEffect( () => {
        getOrganizationInfo()
    }, [activeOrganization]);

    const getOrganizationInfo = async () => {
        try {
            let organizationInfo = await getOrganizationInfoAsync(activeOrganization.inn)
            let bankInfo = await getBankNameAsync({mfo: organizationInfo.mfo, lang})

            setOrganization({
                ...organizationInfo,
                ...bankInfo
            })
        } catch (e) {
            console.log(e);
        }
    }

    const syncCompanyClassCodes = () => {
        invalidateCompanyClassCodesAsync(activeOrganization.inn, lang)
            .then(() => {
                dispatch(loadCompanyProductCatalogsAsync(activeOrganization.inn, lang));
                toast.success(t(lang, 'hippo.user.settings.organization_class_codes.sync.success_toast'));
            })
            .catch(() => toast.error(t(lang, 'hippo.user.settings.organization_class_codes.sync.error_toast')))
    }

    const exportCompanyCatalogs = () => {
        exportCompanyCatalogsToExcel({lang: lang})
            .then(loadedContent => {
                excelFileUploader({
                    content: loadedContent,
                    fileName: t(lang, 'items.common.catalog')
                })
            })
            .catch((error) => {})
    }

    return (
        <Fragment>
            <Row className={'justify-content-between align-items-center'}>
                <Col md={'auto'}>
                    <h2 className={'fw-semi-bold'}>{t(lang, 'hippo.user.settings.profile.title')}</h2>
                </Col>
                <Col md={'auto'}>
                    <Flex direction="column">
                        <IconButton icon={faRefresh} size="sm" onClick={syncCompanyClassCodes} className="mb-2">{t(lang, 'hippo.user.settings.organization_class_codes.sync.button')}</IconButton>
                        <IconButton icon={faFileExport} size="sm" variant="success" onClick={exportCompanyCatalogs}>{t(lang, 'hippo.user.settings.organization_catalogs.export_to_excel')}</IconButton>
                    </Flex>
                </Col>
            </Row>

            <div className="bg-200 p-2 my-2">
                <Row className="d-flex flex-lg-row flex-column align-items-center align-items-lg-start justify-content-center justify-content-lg-start">
                    <Col lg={4} className='d-flex flex-lg-column col-10 m-auto m-lg-0'>
                        <OrganizationChooser/>
                    </Col>
                    <Col lg={8} className='d-flex flex-lg-column col-10 m-auto m-lg-0'>
                            <p className="d-flex flex-md-row flex-column align-items-start align-items-md-center fs--1 fs-lg-0">
                                <b className="me-1">{t(lang, 'hippo.user.settings.profile.company')}: </b>{organization?.name || activeOrganization.name}</p>
                            <p className="d-flex flex-md-row flex-column align-items-start align-items-md-center fs--1 fs-lg-0">
                                <b className="me-1">{t(lang, 'hippo.user.settings.profile.inn')}: </b>{activeOrganization?.inn || <RegisterOrganizationInn />}</p>
                            <p className="d-flex flex-md-row flex-column align-items-start align-items-md-center fs--1 fs-lg-0">
                                <b className="me-1">{t(lang, 'hippo.user.settings.profile.name')}: </b>{organization?.director}</p>
                            <p className="d-flex flex-md-row flex-column align-items-start align-items-md-center fs--1 fs-lg-0">
                                <b className="me-1">{t(lang, 'hippo.user.settings.profile.address')}: </b>{organization?.address}</p>
                            <p className="d-flex flex-md-row flex-column align-items-start align-items-md-center fs--1 fs-lg-0">
                                <b className="me-1">{t(lang, 'hippo.user.settings.profile.bank_code')}: </b>{organization?.account}</p>
                            <p className="d-flex flex-md-row flex-column align-items-start align-items-md-center fs--1 fs-lg-0">
                                <b className="me-1">{t(lang, 'hippo.user.settings.profile.bank_name')}: </b>{organization?.name}</p>
                            <p className="d-flex flex-md-row flex-column align-items-start align-items-md-center fs--1 fs-lg-0">
                                <b className="me-1">{t(lang, 'hippo.user.settings.profile.bank_mfo')}: </b>{organization?.bankId}</p>
                    </Col>
                </Row>
            </div>
        </Fragment>
    );
};

export default ProfileSettings;
